export class CalendarDay {
    public date? = new Date();
    public selected? = false;
    public isStartOfRange? = false;
    public isWithinRange? = false;
    public isEndOfRange? = false;
    public disabled? = false;
    public muted? = false;
    public hidden? = false;
    public isToday? = false;
    public isRangeHovered? = false;
    public isRangeHoveredStart? = false;
    public isRangeHoveredEnd? = false;
    public isFirstDayOnCalendar? = false;
    public isLastDayOnCalendar? = false;
}
